import { AdditionalDocumentType } from "../hooks/useDocuments";

import { addStateHistory } from "./StateHistoryUtil";

export type EcDataModelOrig =  {
    email?: string,
    sha256_email_address?: string;

    phone_number?: string,
    sha256_phone_number?: string,

    address?: {
        first_name?: string,
        sha256_first_name?: string,
        last_name?: string,
        sha256_last_name?: string,
        city:string,
        region:string,
        postal_code: string,
        country: string,
    }
}
    
export type EcDataModelNew =  {
    email?: string,
    phone_number?: string,
    first_name?:string,
    last_name?:string,
    street?:string,
    city?:string,
    region?:string,
    postal_code?:string,
    country?:string
}

interface TrackEventRestModel {
    'agreement-type'?: string,
    'upload-type'?: AdditionalDocumentType,
    'email-address-hash'?: string,
    'phone-hash'?: string,
    'first-name-hash'?: string,
    'last-name-hash'?: string,
    'ip-address'?: string,
    'revenue-amount'?: string,
    'app-id'?: number,
    'user-id'?: number,
    ecData?: EcDataModelNew
}

interface DataLayerModel extends TrackEventRestModel {
    event?: string,
    pageView?: string,
}

declare global {
    interface Window {
        dataLayer: DataLayerModel[];
    }
}

const gtmPushEvent: (an: string, r?: TrackEventRestModel) => void = (eventName, rest) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...rest });
};

// eslint-disable-next-line
const gtmPushEnhancedConversion: (an: string, r?: any) => void = (eventName, rest) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...rest });
};


const gtmPageView = (page: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'page-view', pageView: page });
    addStateHistory(`PageView ${page}`);
};

function trackEvent<T>(
    promise: Promise<T>,
    name: string,
    rest?: TrackEventRestModel,
    submitSuffix: string = 'submit',
    completeSuffix: string = 'complete',
    errorSuffix: string = 'error',
) {
    gtmPushEvent(`${name}-${submitSuffix}`, rest);
    promise.then(
        () => {
            gtmPushEvent(`${name}-${completeSuffix}`, rest);
        },
        () => {
            gtmPushEvent(`${name}-${errorSuffix}`, rest);
        },
    );
    return promise;
}

export { trackEvent, gtmPushEvent, gtmPushEnhancedConversion, gtmPageView };
